import { DateTime } from 'luxon';
import { displayMessage } from '../../../services/helper';

export default [
    {
        field: 'fullName',
        headerName: displayMessage('NAME'),
        width: 200,
        valueGetter: function (params) {
            return `${params.row.first_name || ''} ${params.row.last_name || ''}`
        }
    },
    {
        field: 'email',
        headerName: displayMessage('EMAIL'),
        width: 200,
    },
    {
        field: 'cro_number',
        headerName: displayMessage('CRO_NAME'),
        width: 200,
    },
    {
        field: 'specialization_formatted',
        headerName: displayMessage('SPECIALIZATION'),
        width: 200
    },
    {
        field: 'cell_phone',
        headerName: displayMessage('CELLPHONE'),
        width: 200,
    },
    {
        field: 'cpf',
        headerName: displayMessage('CPF'),
        width: 200,
    },
    {
        field: 'birth_day', type: 'date', headerName: displayMessage('BIRTHDAY'), width: 220, headerClassName: 'grid-headers-bold',
        valueFormatter: (params) => {
            if (!params?.value) { return params?.value }
            const data = DateTime.fromISO(params.value)
            return data.toFormat('dd/MM/yyyy')
        }
    },
]